module.exports = __webpack_public_path__ + "img/bg-poussan.8c086a98.jpg";